import"./CalloutFont.css.ts.vanilla.css";var t="CalloutFont_fontStyle__1589ec81";export{t as fontStyle};
//# sourceMappingURL=CalloutFont.css.vanilla.js.map
